import moment from "moment";

// Dates on the plan and task result sets are SQL Server GETDATE() values - the
// server's own wall clock, already IST. The driver reads datetime columns with
// useUTC on, so they reach the browser tagged as UTC:
//
//     stored 2026-08-01 23:11  ->  "2026-08-01T23:11:00.000Z"
//
// Handing that to moment() converts it into the browser's zone and adds another
// 5:30, which is why a remark posted at 11:11 PM was showing as 4:41 AM the next
// morning. The tag is spurious, so a tagged value is read exactly as it stands.
// A value with no tag - a message added in this browser and not saved yet - is
// already local and is read that way.
const parseServerDateTime = (value) => {
  if (!value) return null;

  const isTagged =
    typeof value === "string" && /(Z|[+-]\d{2}:?\d{2})$/.test(value.trim());

  const parsed = isTagged ? moment.utc(value) : moment(value);
  return parsed.isValid() ? parsed : null;
};

// What the remark threads and the attachment lists print
export const formatServerDateTime = (value) => {
  const parsed = parseServerDateTime(value);
  return parsed ? parsed.format("DD/MM/YYYY, hh:mm A") : "-";
};

// Sorting a thread has to agree with what it prints, so it goes through the same
// reading. A message with no usable date sorts oldest rather than turning the
// comparison into NaN, which leaves the order undefined
export const serverDateTimeValue = (value) => {
  const parsed = parseServerDateTime(value);
  return parsed ? parsed.valueOf() : 0;
};
